import Rollbar from 'rollbar';

type RollbarPayloadLike = {
  level?: string;
  body?: { trace?: { exception?: { description?: string } } };
};

const IGNORED_DESCRIPTIONS = [
  'script error',
  'network error',
  'timeout',
  'request timed out',
  'request aborted',
  'failed to fetch',
  'error getting `reason` from event',
];

const accessToken = process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN;
const enabled = process.env.NODE_ENV === 'production' && !!accessToken;

export const rollbarConfig: Rollbar.Configuration = {
  accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled,
  payload: {
    environment:
      process.env.NEXT_PUBLIC_ROLLBAR_ENV ??
      (typeof window !== 'undefined' ? window.location.host : 'unknown'),
    client: {
      javascript: {
        code_version: process.env.NEXT_PUBLIC_BUILD_NUMBER,
        source_map_enabled: true,
      },
    },
  },
  checkIgnore: (_isUncaught, _args, payload) => {
    const p = payload as RollbarPayloadLike;
    const desc = p.body?.trace?.exception?.description?.toLowerCase();
    if (p.level === 'error' && desc) {
      return IGNORED_DESCRIPTIONS.some((needle) => desc.includes(needle));
    }
    return false;
  },
};

let singleton: Rollbar | null = null;

export function getRollbar(): Rollbar | null {
  if (typeof window === 'undefined') return null;
  if (!enabled) return null;
  if (!singleton) singleton = Rollbar.init(rollbarConfig);
  return singleton;
}
